import React, { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import { ManagementIconActionButton } from "../common/ManagementListLayout";

function AdminUserDeleteDialog({ adminUser, onDelete }) {
  const [open, setOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleClose = () => {
    if (!isSubmitting) {
      setOpen(false);
    }
  };

  const handleDelete = async () => {
    setIsSubmitting(true);

    try {
      const wasDeleted = await onDelete(adminUser);
      if (wasDeleted) {
        setOpen(false);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ManagementIconActionButton
        ariaLabel={`${adminUser.adminUserName}を無効化`}
        tooltip="無効化"
        onClick={() => setOpen(true)}
      >
        <DeleteIcon fontSize="small" />
      </ManagementIconActionButton>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="admin-user-delete-dialog-title"
        aria-describedby="admin-user-delete-dialog-description"
      >
        <DialogTitle id="admin-user-delete-dialog-title">
          管理者削除
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="admin-user-delete-dialog-description">
            管理者：{adminUser.adminUserName}を削除しますか？
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button disabled={isSubmitting} onClick={handleDelete}>
            はい
          </Button>
          <Button disabled={isSubmitting} onClick={handleClose} autoFocus>
            いいえ
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default AdminUserDeleteDialog;
